import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import DataPointsSection from '../components/MeterDataPointsSection';
import ArrowDown from '../../components/ArrowDown/ArrowDown';
import { DataPointWithValue } from '@src/types/DataPoint';

const rectTextProps = {
  fill: 'currentColor',
  stroke: 'none',
  textAnchor: 'right',
  fontSize: '8px',
};

export type BreakerProps = {
  breakerConnected: boolean;
  meterDataPoints?: DataPointWithValue[] | undefined;
  translateXCoordinate: number;
  translateYCoordinate: number;
  meterDataPointsSectionXCoordinate: number;
  meterDataPointsSectionYCoordinate: number;
  feederALabel?: string;
  feederBLabel?: string;
  breakerLabel?: string;
  switchLabel?: string;
  meterLabel?: string;
  resistorLabel?: string;
};

function BreakerStack(props: BreakerProps): ReactElement {
  const {
    breakerConnected,
    meterDataPoints,
    translateXCoordinate,
    translateYCoordinate,
    feederALabel,
    breakerLabel,
    meterLabel,
  } = props;

  return (
    <g transform={`translate(${translateXCoordinate} ${translateYCoordinate})`}>
      <rect
        x={-123}
        y='723'
        width='20'
        height='20'
        fill={breakerConnected ? 'red' : 'gray'}
        strokeWidth={0.5}
      />

      <text x={-90} y={735} {...rectTextProps}>
        {breakerLabel}
      </text>

      <VerticalLine
        translateXCoordinate={-113.5}
        translateYCoordinate={744}
        length={50}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      <ArrowDown xCoordinate={-116} yCoordinate={795} />

      <text x={-180} y={820} fill='currentColor' stroke='none' fontSize='8px'>
        {feederALabel}
      </text>

      <DataPointsSection
        translateXCoordinate={-160}
        translateYCoordinate={880}
        meterDataPoints={meterDataPoints}
        meterLabel={meterLabel || ''}
      />
    </g>
  );
}

export default BreakerStack;
